import { Typography } from "@mui/material";
import SimpleAccordion from "src/qubCommon/Accordions/SimpleAccordion";
import "./Intro.css";
import LegalFiles from "./LegalFiles";

export default function Intro() {
  return (
    <div className="intro-text">
      <p>
        Ο ΛΑΕ /ΟΠΕΚΑ υλοποιεί και φέτος το <strong><u>Πρόγραμμα 5</u></strong> παροχής χρηματικών
        βοηθημάτων σε <strong>τρίτεκνες</strong> και{" "}
        <strong> πολύτεκνες μητέρες</strong>, που είναι συνταξιούχοι
        ή ασφαλισμένες του e-ΕΦΚΑ (ΟΓΑ), καθώς και το νέο <strong><u>Πρόγραμμα 6</u></strong> υποτροφίας <strong>επιτυχόντων για πρώτη φορά στις Πανελλαδικές Εξετάσεις τέκνων τους.</strong>
      </p>

      <p>
        <strong><u>Πρόγραμμα 5: Τρίτεκνες / Πολύτεκνες Μητέρες</u></strong>
        <br />
        Το πρόγραμμα απευθύνεται σε{" "}
        <strong>
          εξακόσιες (600)  πολύτεκνες μητέρες και δύο χιλιάδες
          πεντακόσιες (2.500) τρίτεκνες
        </strong>
        . Οι μητέρες πρέπει επίσης να είναι δικαιούχοι περίθαλψης με ενεργή ασφαλιστική ικανότητα και ειδικότερα τα τέκνα με δικαίωμα περίθαλψης απορρέει από δικαιούχο του ΛΑΕ/ΟΠΕΚΑ.
      </p>
      <p>
        <strong><u>Πρόγραμμα 6: Υποτροφίες Επιτυχόντων Τέκνων τους στις Πανελλαδικές Εξετάσεις (Νέο Πρόγραμμα) </u></strong>
        <br />
        Το πρόγραμμα απευθύνεται σε{" "}
        <strong>
          εξακόσια πενήντα (650) επιτυχόντα για πρώτη φορά στις Πανελλαδικές εξετάσεις τέκνα τρίτεκνων και πολύτεκνων μητέρων
        </strong>
        . Οι μητέρες υποβάλλουν τις σχετικές αιτήσεις και θα πρέπει να πληρούν τις προϋποθέσεις του (παραπάνω) Προγράμματος 5.
      </p>
      <p>
        <p>
          Σε περίπτωση που εκδηλωθεί ενδιαφέρον από αριθμό δικαιούχων πέραν του
          οριζομένου, ανά κατηγορία ορίου, η επιλογή γίνεται με κλήρωση, η οποία
          διεξάγεται με τη διαδικασία που ορίζεται με απόφαση του Δ.Σ. του
          ΟΠΕΚΑ.
        </p>
      </p>

      <p>
        <strong>Προϋποθέσεις: </strong>
        Δικαίωμα συμμετοχής στο πρόγραμμα παροχής χρηματικών βοηθημάτων-βραβείων
        σε <strong>τρίτεκνες</strong> και <strong>πολύτεκνες</strong> (μητέρες
        τουλάχιστον τεσσάρων τέκνων) έχουν οι μητέρες που εμπίπτουν στις
        περιπτώσεις:
      </p>
      <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
        <li style={{ fontSize: "1.05rem", marginBottom: "12px" }}>
          Είναι ασφαλισμένες του e-ΕΦΚΑ (ΟΓΑ) και ασφαλιστικά ενήμερες κατά την{" "}
          <strong>31η Δεκεμβρίου 2024</strong>,
        </li>
        <li style={{ fontSize: "1.05rem", marginBottom: "12px" }}>
          Είναι οι συνταξιούχοι του e-ΕΦΚΑ (ΟΓΑ),
        </li>
        <li style={{ fontSize: "1.05rem", marginBottom: "12px" }}>
          Είναι συνταξιούχοι του Λογαριασμού Ανασφάλιστων Υπερηλίκων του άρθρου
          1 του ν.1296/1982 (ΦΕΚ 128 Α’), όπως ισχύει,
        </li>
        <li style={{ fontSize: "1.05rem", marginBottom: "12px" }}>
          Είναι υπάλληλοι ή/και συνταξιούχοι πρώην υπάλληλοι του ΟΠΕΚΑ, με την
          προϋπόθεση ότι καταβάλουν τις προβλεπόμενες εισφορές,
        </li>
        <li style={{ fontSize: "1.05rem", marginBottom: "12px" }}>
          Είναι υπάλληλοι του e-ΕΦΚΑ, που μεταφέρθηκαν από τον ΟΓΑ και ήταν
          εγγεγραμμένες στο Μητρώο Δικαιούχων του ΛΑΕ, με την προϋπόθεση ότι
          καταβάλουν τις προβλεπόμενες εισφορές και παραμένουν υπάλληλοι του
          e-ΕΦΚΑ.
        </li>
      </ul>
      <br />
      <p>
        Το ποσό των χρηματικών βραβείων στις τρίτεκνες και πολύτεκνες μητέρες
        καθορίζεται με απόφαση της Διαχειριστικής Επιτροπής του ΛΑΕ, σύμφωνα με
        τα οριζόμενα στο άρθρο 3 του ν.3050/2002.
      </p>
      <p>
        <strong>
          Κάθε αίτηση που θα υποβληθεί ηλεκτρονικά, επέχει θέση υπεύθυνης δήλωσης{" "}
        </strong>{" "}
        του άρθρου 8 του ν. 1599/1986 (ΦΕΚ 75 Α΄) για τα στοιχεία που
        περιέχονται σε αυτήν
      </p>

      <LegalFiles />
    </div >
  );
}
